import {decodeConsentString} from 'consent-string';
import {INTERVAL_24, LASTSHOW_COOKIE_NAME, TESTPERSIST_COOKIE_NAME} from '../constants';
import {existsConsentCookie, getConsentCookie} from '../services/consent';
import {setCookie, existsCookie, getCookie, deleteCookie} from '../services/cookie';
import {getNextShow, setNextShow} from '../services/measurement';
import {logger} from '../services/logger';
import {getItem, setItem, itemExists, syncStorage} from '../services/storage';

const INTERVAL_12 = INTERVAL_24 / 2;
const INTERVAL_72 = INTERVAL_24 * 3;

/**
 * Checks if it is posible to show dialog - based on time intervals
 * @returns {boolean}
 */
export const checkNoOpenInterval = () => {
  logger(1800, 'Checking time interval.');

  let nextShow = Date.now() - 1; // only for first run
  let stage = 0;

  syncStorage(LASTSHOW_COOKIE_NAME);
  let data = getItem(LASTSHOW_COOKIE_NAME);
  getNextShow(data);
  if (data) {
    data = data.split('|');
    nextShow = parseInt(data[0], 10);
    stage = parseInt(data[1], 10);
  }
  if (Date.now() < nextShow) {
    logger(1801, 'Too short time interval - do not open dialog.');
    return false;
  }
  // sync with current time
  nextShow = Date.now();
  // show
  if (stage <= 2) {
    // first and second 12 hour increment
    nextShow += INTERVAL_12;
  } else if (stage <= 7) {
    // 24 hours increment up to the 7th day
    nextShow += INTERVAL_24;
  } else {
    nextShow += INTERVAL_72; // next increments are by 3 days (72 hours)
    stage--;
  }
  setItem(`${nextShow}|${++stage}`, LASTSHOW_COOKIE_NAME);
  if (itemExists(LASTSHOW_COOKIE_NAME)) {
    setNextShow(getItem(LASTSHOW_COOKIE_NAME));
  }
  syncStorage(LASTSHOW_COOKIE_NAME);

  return true;
};

export const resetCheckNoOpenInterval = () => {
  setCookie(`${Date.now()}|0`, LASTSHOW_COOKIE_NAME);
};

/**
 * Checks if page contains viewport meta tag
 * @returns {boolean}
 */
const hasViewport = () => document.querySelector('meta[name="viewport"][content*="device-width"]') !== null;

/**
 * Checks if mobile device
 * @returns {boolean}
 */
const isMobile = () => {
  const ua = navigator.userAgent.toLowerCase();
  const isTablet = /(ipad|tablet)/.test(ua);
  return (typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1) && !isTablet;
};

/**
 * Checks if user loads non-responsive page on mobile
 * @returns {boolean}
 */
export const mobileNonResponsive = () => isMobile() && !hasViewport();

/**
 * Apple platform list
 */
const applePlatformList = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K', 'darwin', 'iPhone', 'iPad', 'iPod'];

/**
 * Is this an Apple device?
 *
 * @returns {boolean}
 */
export const isApplePlatform = applePlatformList.includes(window.navigator.platform);

const TEST_COOKIE_NAME = 'cmptestcookie';

/**
 * Checks posibility to storage cookies, etc...
 * @returns {boolean}
 */
const checkStorageAvailability = () => {
  setCookie(1, TEST_COOKIE_NAME);
  const result = existsCookie(TEST_COOKIE_NAME);
  logger(1802, 'Checking checkStorageAvailability: ', result);
  deleteCookie(TEST_COOKIE_NAME);
  return result;
};

const check = () => {
  logger(1803, 'Check storage hold capability');
  if (existsCookie(TESTPERSIST_COOKIE_NAME)) {
    const result = parseInt(getCookie(TESTPERSIST_COOKIE_NAME), 10);
    logger(1804, 'Read stored test cookie');
    if (Date.now() >= result + INTERVAL_24) {
      // is cookie stored at least 24h
      logger(1805, 'Stored at least 24h');
      return true;
    } else {
      logger(1806, 'Stored less than 24h - fail end - CMP.');
      return false;
    }
  } else {
    logger(1807, 'Start store check - save cookie - fail - end CMP');
    setCookie(Date.now(), TESTPERSIST_COOKIE_NAME);
    return false;
  }
};

export const isStorageEnabled = checkStorageAvailability();
export const isCapableStoreAndHoldCookies = check();

export const checkForUpdate = global => {
  if (!existsConsentCookie()) {
    logger(1808, 'No euconsent cookie found in local domain.');
    return true;
  }

  const decodedLocal = decodeConsentString(getConsentCookie());
  const decodedGlobal = decodeConsentString(global);

  logger(1809, 'Checking local and global cookie time.');
  return decodedLocal.lastUpdated < decodedGlobal.lastUpdated || decodedLocal.created < decodedGlobal.created;
};
